import { setSelectedFilials } from "@/entities/dealer";
import { getUser } from "@/entities/viewer/slice";
import { AuthForm } from "@/features";
import { CookieRow } from "@/features/cookieRow/CookieRow";
import { ModalWindow, PATHNAMES, usePagination } from "@/shared";
import { getCookieValue } from "@/shared/helpers/GetCookieValue";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { SetupInterceptor } from "@/shared/http";
import { Sidebar } from "@/widgets";
import { ReportLoader } from "@/widgets/reportLoader/ReportLoader";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import { useDrawer } from "./providers/DrawerProvider/useDrawer";
import Layout from "./routing/Layout";

const {
  loginPath,
  recoveryPassPath,
  nomenclaturePath,
  remainsPath,
  ordersPath,
  cookiePage,
  faqPath,
} = PATHNAMES;

export const App = () => {
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [isSidebarSmall, setIsSidebarSmall] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.viewer);
  const { showAuthModal } = useAppSelector((state) => state.app);

  const navigate = useNavigate();
  const location = useLocation();
  const { setPage, setSecondPage } = usePagination();

  const path = location.pathname;
  const isPasswordResorePath = path.includes(recoveryPassPath);
  const { closeDrawer } = useDrawer();

  const token = getCookieValue("access-token");
  const accepted = getCookieValue("accepted-cookie");

  const NavigateFunctionComponent = () => {
    const [ran, setRan] = useState(false);

    if (!ran) {
      SetupInterceptor(navigate);
      setRan(true);
    }

    return <></>;
  };

  useEffect(() => {
    setIsAuth(() => !!token);
    if (!token && !isPasswordResorePath && !cookiePage) {
      navigate(loginPath);
    }
    closeDrawer();
    dispatch(setSelectedFilials([]));
    if (!path.includes(faqPath.root)) {
      if (path.includes(ordersPath)) {
        setPage(1);
      }
      if (path.includes(remainsPath) || path.includes(nomenclaturePath)) {
        setPage(1);
        setSecondPage(1);
      }
    }
  }, [path, token]);

  useEffect(() => {
    const isMini = localStorage.getItem("sidebar-mini");
    setIsSidebarSmall(!!isMini);

    if (token) {
      dispatch(getUser());
    }
  }, []);

  return (
    <main className={styles.container}>
      <NavigateFunctionComponent />
      {isAuth && !isLoading && path !== loginPath && (
        <>
          <ReportLoader />
          <Sidebar
            isSidebarSmall={isSidebarSmall}
            setIsSidebarSmall={setIsSidebarSmall}
          />
        </>
      )}
      <Layout />
      {showAuthModal && (
        <ModalWindow opaqueBackdrop>
          <AuthForm />
        </ModalWindow>
      )}
      {!accepted && path !== cookiePage && !showAuthModal && <CookieRow />}
    </main>
  );
};
